<script lang="ts" setup>
import { onMounted, toRefs } from 'vue';
import { useDisplay } from 'vuetify';
import { storeToRefs } from 'pinia';
import useUiStore from './stores/ui';
import { isAndroidTablet, isIpad } from './util/ui'; // TODO: replace with vuetify

const props = defineProps({ theme: { type: String, default: 'default' } });
const { theme } = toRefs(props);

const uiStore = useUiStore();
const { isTableOfContentVisible, isAnnotationsDrawerVisible } = storeToRefs(uiStore);
const { toggleDrawerAndControls, closeTableOfContentDrawer, toggleAnnotationsDrawer } = uiStore;
const { mdAndUp, mdAndDown } = useDisplay();

const dismissDrawersIfInIframe = () => {
  const { activeElement } = document;
  if (activeElement && activeElement.tagName === 'IFRAME' && isTableOfContentVisible.value) {
    closeTableOfContentDrawer();
  }
  if (activeElement && activeElement.tagName === 'IFRAME' && isAnnotationsDrawerVisible.value) {
    toggleAnnotationsDrawer(false);
  }
};

const setClassInBody = () => {
  const el = document.body;
  if (isAndroidTablet()) {
    el.classList.add('media-device-android-tablet');
  } else if (isIpad()) {
    el.classList.add('media-device-ipad');
  } else if (mdAndUp.value) {
    el.classList.add('media-device-md-and-up');
  } else if (mdAndDown.value) {
    el.classList.add('media-device-md-and-down');
  }
};

onMounted(() => {
  setInterval(dismissDrawersIfInIframe, 100);
  // setInterval(setFocusToParent, 100);
  setClassInBody();
  setTimeout(() => {
    toggleDrawerAndControls(true, false);
  }, 3000);
});
</script>

<template>
  <div id="app-wrapper" :class="`${theme} text-on-surface book-player`">
    <slot />
  </div>
</template>

<style scoped lang="scss">
html {
  overflow-y: auto !important;
}
#app-wrapper {
  width: 100vw !important;
  height: 100%;
  overflow: hidden !important;
  &.sondo {
    .theme--light.v-application {
      background: #1e1e1e; //to ensure no white background behind app bars
    }
  }
}
#app {
  .default {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
}
</style>
